import {
  buildVendorRegistrationPayload,
  VENDOR_PROFILE_FIELDS,
  mapApiResponseToFormValues,
  initialValues,
} from "../vendorProfile/vendorProfileForm";

/** Normalize API record field names before mapping (amendment-only aliases). */
export const normalizeVendorApiRecord = (apiObj) => {
  const raw = Array.isArray(apiObj) ? apiObj[0] : apiObj;
  if (!raw || typeof raw !== "object") return raw;

  const merged = { ...raw };
  for (let i = 1; i <= 5; i += 1) {
    const formKey = `top5Customer${i}`;
    const legacyKey = `customer${i}`;
    if (
      (merged[formKey] === undefined || merged[formKey] === null) &&
      merged[legacyKey] != null
    ) {
      merged[formKey] = merged[legacyKey];
    }
  }
  if (merged.statutoryPanNo == null && merged.panNo != null) {
    merged.statutoryPanNo = merged.panNo;
  }
  if (merged.statutoryGstNo == null && merged.gstNo != null) {
    merged.statutoryGstNo = merged.gstNo;
  }
  for (let i = 1; i <= 3; i += 1) {
    const formKey = `turnoverRevenue${i}`;
    const legacyKey = `turnoverYear${i}Revenue`;
    if (merged[formKey] == null && merged[legacyKey] != null) {
      merged[formKey] = merged[legacyKey];
    }
  }
  return merged;
};

export const mapVendorApiToFormValues = (apiObj) =>
  mapApiResponseToFormValues(normalizeVendorApiRecord(apiObj), initialValues);

const normalizeCompareValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "boolean") return value ? "Y" : "N";
  if (value instanceof Date) return value.toISOString();
  if (typeof File !== "undefined" && value instanceof File) return "__FILE__";
  const trimmed = String(value).trim();
  if (trimmed !== "" && /^-?\d+(\.\d+)?$/.test(trimmed)) {
    const n = Number(trimmed);
    if (!Number.isNaN(n)) return String(n);
  }
  return trimmed;
};

/**
 * Compare registration baseline vs amendment form values; returns Set of changed field names.
 */
export const computeAmendmentChangedFields = (
  registrationValues,
  amendmentValues,
) => {
  const regPayload = buildVendorRegistrationPayload(
    registrationValues,
    VENDOR_PROFILE_FIELDS,
  );
  const amdPayload = buildVendorRegistrationPayload(
    amendmentValues,
    VENDOR_PROFILE_FIELDS,
  );
  regPayload.overallComments = normalizeCompareValue(
    registrationValues?.overallComments,
  );
  amdPayload.overallComments = normalizeCompareValue(
    amendmentValues?.overallComments,
  );

  const keys = new Set([
    ...Object.keys(regPayload),
    ...Object.keys(amdPayload),
    "overallComments",
  ]);
  const changed = new Set();
  keys.forEach((key) => {
    if (
      normalizeCompareValue(regPayload[key]) !==
      normalizeCompareValue(amdPayload[key])
    ) {
      changed.add(key);
    }
  });
  return changed;
};

export const getRegistrationDisplayValue = (registrationValues, fieldName) => {
  if (!registrationValues) return "";
  const val = registrationValues[fieldName];
  if (val === null || val === undefined) return "";
  if (typeof val === "object" && !(val instanceof Date)) return "";
  return String(val);
};
